import reactEnvVar from '../reactEnvVar';
import createCacheInstance, { localCache } from './caches';

const createLocalCache = () => {
  if (!localCache) createCacheInstance(reactEnvVar.itemKeyPrefix);
};

export default createLocalCache;
